// extracted by mini-css-extract-plugin
export default {"wrapper":"Error404_wrapper__Xhyrz","sadFace":"Error404_sadFace__kBvc1","textWrapper":"Error404_textWrapper__wSN4a","backLink":"Error404_backLink__e9MJw","or":"Error404_or__B3JXm"};